<div class="org-details">
  <app-organization-edit
    [isCreating]="isCreating"
    [id]="id"
    [uiTemplateConfig]="ui_template"
    [isSimpleOnboarding]="isSimpleOnboarding"
  ></app-organization-edit>
</div>
